import axios from "axios";

// Handles saving of eventDetails in bulk (ie: when saving a course with multiple events which can have cross-event related dependencies)
export async function remoteBulkSaveEventDetails(courseUUID = false, data) {
    if (!!courseUUID === false) {
        return {
            errors: ["missing course UUID"],
            results: {}
        };
    }

    let result = null;
    let errors = false;

    // remove any deleted objects:
    data = data.filter(event => !event.mark_delete);

    result = await axios
        .post(`/v1/courses/${courseUUID}/events/`, data)
        .then((result) => result)
        .catch((error) => {
            if (error.response) {
                errors = error?.response?.data?.map((eventError) => {
                    let errors = [];

                    for (const [field, error] of Object.entries(eventError)) {
                        errors.push({ field: field, error: error[0] });
                    }
                    return errors;
                });
            }
        });

    return {
        result,
        errors
    };
}

// used to save a single event Entry and has logic for determining new vs existing (might be deprecated)
// Please be aware that when saving an individual event you might NOT be able to check for/fault on cross-event dependencies / exclusions
export async function remoteSaveEventDetails(courseUUID = false, eventUUID = false, data) {
    if (!!courseUUID === false) {
        return {
            errors: ["missing course UUID"],
            results: {}
        };
    }

    let result = null;

    let errors = [];

    if (!!eventUUID === false) {
        result = await axios
            .post(`/v1/courses/${courseUUID}/events/`, data)
            .then((result) => result)
            .catch((error) => {
                if (error.response) {
                    for (const [field, error] of Object.entries(error.response.data)) {
                        errors.push({ field: field, error: error[0] });
                    }
                }
            });
    } else {
        result = await axios
            .patch(`/v1/courses/${courseUUID}/events/${eventUUID}/`, data)
            .then((result) => result)
            .catch((error) => {
                if (error.response) {
                    for (const [field, error] of Object.entries(error.response.data)) {
                        errors.push({ field: field, error: error[0] });
                    }
                }
            });
    }

    return {
        result,
        errors
    };
}

export async function remoteDeleteEvent(courseUUID = false, eventUUID = false) {
    let errors = [];
    let result = null;

    if (!!courseUUID === false) {
        errors.push("missing course UUID");
    }
    if (!!eventUUID === false) {
        errors.push("missing event UUID");
    }

    if (errors.length > 0) {
        return {
            result,
            errors
        };
    }

    result = await axios
        .delete(`/v1/courses/${courseUUID}/events/${eventUUID}/`)
        .then((result) => result)
        .catch((error) => {
            if (error.response) {
                for (const [field, error] of Object.entries(error.response.data)) {
                    errors.push({ field: field, error: error[0] });
                }
            }
        });

    return {
        result,
        errors
    };
}
